import type { EnhancedStoreCustomer } from '@marxbiotech/shared-types/medusa';
import Container from '@modules/common/components/container';
import LoginNav from '@modules/layout/templates/login-nav';
import React from 'react';

import { AccountNav, type AccountNavItem } from '../components/account-nav';

interface AccountLayoutProps {
  customer: EnhancedStoreCustomer | null;
  isLoggedIn: boolean;
  isActive: boolean;
  navItems: AccountNavItem[];
  children: React.ReactNode;
}

const AccountLayout: React.FC<AccountLayoutProps> = ({
  customer,
  isLoggedIn,
  isActive,
  navItems,
  children,
}) => {
  if (!isActive) {
    return (
      <div
        className="bg-white-10 small:py-8 small:pt-0 relative z-40 -mt-[70px] h-full min-h-[calc(100vh-225px)] flex-1 md:-mt-[180px]"
        data-testid="account-page"
      >
        <LoginNav isLoggedIn={isLoggedIn} />
        <div className="lg:py-8">{children}</div>
      </div>
    );
  }

  return (
    <div className="small:py-8 flex-1" data-testid="account-page">
      <Container className="flex h-full flex-1 flex-col bg-white">
        <div className="small:grid-cols-[240px_1fr] grid grid-cols-1 lg:py-8">
          <div>
            <AccountNav customer={customer} navItems={navItems} />
          </div>
          {children}
        </div>
      </Container>
    </div>
  );
};

export default AccountLayout;
